<!--急救设备（无人车，无人机） 编辑 / 补写-->
<template>
  <div v-if="showContent">
    <basic-info ref="basicRef"/>
    <situation ref="situationRef"/>
    <drug ref="drugRef"/>
    <hospital-emergency ref="hospitalRef"/>
    <el-button class="button-patient-save" @click="saveData">保存</el-button>
    <my-dialog
      :dialog-carted="dialogFormVisible"
      form-title="提示"
      :width="320"
      @confirmOk="dialogFormVisible = false"
    >
      <template #content>
        <div>保存成功</div>
      </template>
    </my-dialog>
  </div>
</template>

<script>
import BasicInfo from "@/components/patientsSmart/BasicInfo.vue";
import Situation from "@/components/patientsSmart/Situation.vue";
import Drug from "@/components/patientsSmart/Drug.vue";
import HospitalEmergency from "@/components/patientsSmart/HospitalEmergency.vue";
import MyDialog from "@components/customDialog/MyDialog.vue";
import { editSmartPatientInfo, getPatient } from "@/api/hospitalList";
import "@/assets/css/patients.scss";
import { showWindowMessage } from "@utils/notification";

export default {
  name: "AddPatientSmart",
  components: {
    BasicInfo,
    Situation,
    Drug,
    MyDialog,
    HospitalEmergency
  },
  data() {
    return {
      showContent: false,
      patientID: "",
      drugInfo: {},
      dialogFormVisible: false,
      isAddPatient: false, // 是否属于编辑
      isWriteMore: false, // 是否属于补写
      patient: null,
    };
  },
  mounted() {
    this.patientID = this.$route.params.id;
    this.getPatientInfo();
    const all = this.$route.path.split("/");
    this.isAddPatient = all[1] === "addPatientSmart";
    this.isWriteMore = all[1] === "writeMoreSmart";
  },
  methods: {
    async getPatientInfo() {
      try {
        const patient = await getPatient(this.patientID);
        patient.pageInfo = {
          isWriteMore: this.isWriteMore,
          isAddPatient: this.isAddPatient,
          isShowPatient: this.isShowPatient,
        };
        this.$store.commit("updateShowOrEditPatientInfo", patient);
        this.showContent = true;
        this.patient = patient;
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    async saveData() {
      const { nobody_medicalstatus } = this.$refs.basicRef.form;
      const { subject, medicalhistory_numbers } = nobody_medicalstatus;
      const {
        content: prepare_content,
        number1,
        number2,
        number3,
      } = this.$refs.drugRef.$refs.editRef.form;
      const { operate } = this.$refs.hospitalRef;
      const { illness_level, details } = this.$refs.situationRef.$refs.editRef.form;
      const data = {
        subject,
        medicalhistory_numbers,
        type: illness_level,
        rooms: [
          {
            name: "急诊手术室",
            amount: number1
          },
          {
            name: "急诊EICU",
            amount: number2
          },
          {
            name: "急诊综合病房",
            amount: number3
          },
        ],
        content: details,
        prepare_content,
        operate
      };
      try {
        const object = this.patient.ambulance.type;
        const method = this.isWriteMore ? "PUT" : "POST";
        const { code, msg } = await editSmartPatientInfo(this.patientID, JSON.stringify(data), method, object);
        showWindowMessage(code === 200 ? 4 : 3, msg, this);
      } catch (e) {
        console.log(e);
        showWindowMessage(3, e, this);
      }
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
